import { ProjectImportsAPIType } from "shared/api/serializer/serializer"
import { AttachmentsAPIType } from "shared/types/Attachment"
import {
  ProjectsAPIType,
  SpecialPriceGroupsAPIType
} from "shared/types/Project"

import { ClarificationRequestsAPIType } from "entities/clarification-requests/types/ClarificationRequest"
import { TeamInvitationsAPIType } from "entities/team-invitations/types/TeamInvitation"
import { TeamMembersAPIType } from "entities/team-members/types/TeamMember"
import { TeamsAPIType } from "entities/teams/types/Team"

import { createSerializer } from "./createSerializer"
import { dupliateEntitiesSerializer } from "./duplicateEntititesSerializer"
import { deleteProjectChildrenSerializer } from "./project/deleteProjectChildrenSerializer"
import { floorSerializer } from "./project/floorSerializer"
import { productPositionSerializer } from "./project/productPositionSerializer"
import { projectShareLinkSerializer } from "./project/projectShareLinkSerializer"
import { roomSerializer } from "./project/roomSerializer"
import { deleteProfileProposalSerializer } from "./user-space/deleteUserProfileSerializer"

export const bodySerializers = {
  project: createSerializer(ProjectsAPIType),
  shareLink: projectShareLinkSerializer,
  productPosition: productPositionSerializer,
  deleteUserProfile: deleteProfileProposalSerializer,
  floor: floorSerializer,
  room: roomSerializer,
  specialPriceGroup: createSerializer(SpecialPriceGroupsAPIType),
  duplicateEntity: dupliateEntitiesSerializer,
  deleteProjectChildren: deleteProjectChildrenSerializer,
  attachment: createSerializer(AttachmentsAPIType),
  team: createSerializer(TeamsAPIType),
  teamMember: createSerializer(TeamMembersAPIType),
  teamInvitation: createSerializer(TeamInvitationsAPIType),
  clarificationRequest: createSerializer(ClarificationRequestsAPIType),
  projectImport: createSerializer(ProjectImportsAPIType)
}
